// @flow
'use strict';

import * as React from 'react';

import type { ITributacaoIbsCbs } from '../../../types_imposto';

import ColumnDetalhes from '../../../../../common/detalhes_documento/column_detalhes';
import RowDetalhes from '../../../../../common/detalhes_documento/row_detalhes';

type TributacaoIbsCbsProps = {
  tributacaoIbsCbs? : ITributacaoIbsCbs,
};

export default function TributacaoIbsCbs({ tributacaoIbsCbs } : TributacaoIbsCbsProps) {
  return (
    <>
      <h3>Tributação IBS / CBS</h3>
      <RowDetalhes data={ tributacaoIbsCbs }>
        <ColumnDetalhes field="cst" width="25%">CST</ColumnDetalhes>
        <ColumnDetalhes field="cClassTrib" width="25%">Cód. Class. Tributária</ColumnDetalhes>
        <ColumnDetalhes field="indDoacao" width="25%">Ind. Doação</ColumnDetalhes>
        <ColumnDetalhes field="vBc" type="moeda" width="25%">BC Comum</ColumnDetalhes>
      </RowDetalhes>

      <h4>IBS / CBS da UF</h4>
      <RowDetalhes data={ tributacaoIbsCbs?.ibsCbsUF } className="no-margin-bottom">
        <ColumnDetalhes field="aliquotaIbsUF" type="percentual" width="25%">Alíquota IBS Estadual</ColumnDetalhes>
        <ColumnDetalhes field="percDiferimento" type="percentual" width="25%">Perc. Diferimento</ColumnDetalhes>
        <ColumnDetalhes field="valorDiferimento" type="moeda" width="25%">Valor Diferimento</ColumnDetalhes>
        <ColumnDetalhes field="valorTribDevolvido" type="moeda" width="25%">Valor Tributo Devolvido</ColumnDetalhes>
      </RowDetalhes>
      <RowDetalhes data={ tributacaoIbsCbs?.ibsCbsUF }>
        <ColumnDetalhes field="percRedAliquota" type="percentual" width="25%">Perc. Red. Alíquota</ColumnDetalhes>
        <ColumnDetalhes field="aliquotaEfetivaIbsUF" type="percentual" width="25%">Alíquota Efetiva IBS UF</ColumnDetalhes>
        <ColumnDetalhes field="valorIbsUF" type="moeda" width="50%">Valor IBS UF</ColumnDetalhes>
      </RowDetalhes>

      <h4>IBS / CBS do Município</h4>
      <RowDetalhes data={ tributacaoIbsCbs?.ibsCbsMunicipio } className="no-margin-bottom">
        <ColumnDetalhes field="aliquotaIbsMun" type="percentual" width="25%">Alíquota IBS Municipal</ColumnDetalhes>
        <ColumnDetalhes field="percDiferimento" type="percentual" width="25%">Perc. Diferimento</ColumnDetalhes>
        <ColumnDetalhes field="valorDiferimento" type="moeda" width="25%">Valor Diferimento</ColumnDetalhes>
        <ColumnDetalhes field="valorTribDevolvido" type="moeda" width="25%">Valor Tributo Devolvido</ColumnDetalhes>
      </RowDetalhes>
      <RowDetalhes data={ tributacaoIbsCbs?.ibsCbsMunicipio }>
        <ColumnDetalhes field="percRedAliquota" type="percentual" width="25%">Perc. Red. Alíquota</ColumnDetalhes>
        <ColumnDetalhes field="aliquotaEfetivaIbsMun" type="percentual" width="25%">Alíquota Efet. IBS Mun.</ColumnDetalhes>
        <ColumnDetalhes field="valorIbsMun" type="moeda" width="50%">Valor IBS Município</ColumnDetalhes>
      </RowDetalhes>

      <RowDetalhes data={ tributacaoIbsCbs }>
        <ColumnDetalhes field="valorIbsUFMun" type="moeda">Valor do IBS (UF + Mun)</ColumnDetalhes>
      </RowDetalhes>

      <h4>CBS</h4>
      <RowDetalhes data={ tributacaoIbsCbs?.cbs } className="no-margin-bottom">
        <ColumnDetalhes field="aliquotaCbs" type="percentual" width="25%">Alíquota CBS</ColumnDetalhes>
        <ColumnDetalhes field="percDiferimento" type="percentual" width="25%">Perc. Diferimento CBS</ColumnDetalhes>
        <ColumnDetalhes field="valorDiferimento" type="moeda" width="25%">Valor Diferimento CBS</ColumnDetalhes>
        <ColumnDetalhes field="valorCbsDevolvida" type="moeda" width="25%">Valor CBS Devolvida</ColumnDetalhes>
      </RowDetalhes>
      <RowDetalhes data={ tributacaoIbsCbs?.cbs }>
        <ColumnDetalhes field="percReducaoCbs" type="percentual" width="25%">Perc. Redução CBS</ColumnDetalhes>
        <ColumnDetalhes field="aliquotaEfetivaCbs" type="percentual" width="25%">Alíquota Efetiva CBS</ColumnDetalhes>
        <ColumnDetalhes field="valorCbs" type="moeda" width="50%">Valor CBS</ColumnDetalhes>
      </RowDetalhes>

      <h4>Tributação Regular</h4>
      <RowDetalhes data={ tributacaoIbsCbs?.tributacaoRegular } className="no-margin-bottom">
        <ColumnDetalhes field="cstTribRegular" width="25%">CST Trib. Regular</ColumnDetalhes>
        <ColumnDetalhes field="codClassTrib" width="25%">Cód. Class. Tributária</ColumnDetalhes>
        <ColumnDetalhes field="aliquotaEfetivaUF" type="percentual" width="25%">Alíquota Efetiva UF</ColumnDetalhes>
        <ColumnDetalhes field="valorTribUF" type="moeda" width="25%">Valor Tributo UF</ColumnDetalhes>
      </RowDetalhes>
      <RowDetalhes data={ tributacaoIbsCbs?.tributacaoRegular }>
        <ColumnDetalhes field="aliqEfetivaMun" type="percentual" width="25%">Alíquota Efetiva Mun.</ColumnDetalhes>
        <ColumnDetalhes field="valorTribMun" type="moeda" width="25%">Valor Tributo Mun.</ColumnDetalhes>
        <ColumnDetalhes field="aliquotaEfetivaCbs" type="percentual" width="25%">Alíquota Efetiva CBS</ColumnDetalhes>
        <ColumnDetalhes field="valorTribCbs" type="moeda" width="25%">Valor Tributo CBS</ColumnDetalhes>
      </RowDetalhes>

      <h4>IBS e CBS em Compras Governamentais</h4>
      <RowDetalhes data={ tributacaoIbsCbs?.ibsCbsComprasGov } className="no-margin-bottom">
        <ColumnDetalhes field="aliquotaIbsUF" type="percentual" width="25%">Alíquota IBS UF</ColumnDetalhes>
        <ColumnDetalhes field="valorTribIbsUF" type="moeda" width="25%">Valor Tributo IBS UF</ColumnDetalhes>
        <ColumnDetalhes field="aliquotaIbsMun" type="percentual" width="25%">Alíquota IBS Município</ColumnDetalhes>
        <ColumnDetalhes field="valorTribMun" type="moeda" width="25%">Valor Tributo Município</ColumnDetalhes>
      </RowDetalhes>
      <RowDetalhes data={ tributacaoIbsCbs?.ibsCbsComprasGov }>
        <ColumnDetalhes field="aliquotaIbsCbs" type="percentual" width="25%">Alíquota IBS do CBS</ColumnDetalhes>
        <ColumnDetalhes field="valorTribCbs" type="moeda" width="75%" colSpan={ 3 }>Valor Tributo CBS</ColumnDetalhes>
      </RowDetalhes>

      <h4>Estorno de Crédito</h4>
      <RowDetalhes data={ tributacaoIbsCbs?.estornoCredito }>
        <ColumnDetalhes field="valorIbsEstornado" type="moeda" width="50%">Valor IBS a ser estornado</ColumnDetalhes>
        <ColumnDetalhes field="valorCbsEstornado" type="moeda" width="50%">Valor CBS a ser estornado</ColumnDetalhes>
      </RowDetalhes>
    </>
  );
}
